import styled from 'styled-components';
import { DropdownMenuItem } from 'components/dropdown/dropdown';
import { ChevronDown } from 'lucide-react';

export const TimeRangeDropdownItem = styled(DropdownMenuItem).attrs<{
  $isSelected?: boolean;
}>(({ $isSelected }) => ({
  className: `flex flex-row items-center h-8 px-1.5 py-1 gap-1.5 isolate w-full rounded-lg flex-none order-0 self-stretch flex-grow-0 cursor-pointer ${
    $isSelected ? 'bg-[rgba(84,110,180,0.1)]' : ''
  }`,
}))<{ $isSelected?: boolean }>``;

export const DropdownItemText = styled.div.attrs({
  className:
    'flex-1 text-sm font-medium leading-5 text-gray-950 font-["Lato"] z-[1] overflow-hidden text-ellipsis whitespace-nowrap',
})``;

export const DropdownItemCheckWrapper = styled.div.attrs({
  className: 'flex-none w-4 h-4 flex items-center justify-center z-[2]',
})``;

export const ChevronDownIcon = styled(ChevronDown).attrs({
  className: 'h-4 w-4 opacity-50',
})``;

export const FilterDropdownActiveLabel = styled.span.attrs({
  className: 'text-sm font-medium text-primary',
})``;

export const FilterDropdownTrigger = styled.button.attrs({
  type: 'button',
  className:
    'flex items-center justify-between px-2.5 py-1.5 border border-slate-200 rounded-md bg-white cursor-pointer hover:bg-slate-50 min-w-[140px]',
})``;

export const FilterDropdownLabel = styled.span.attrs({
  className: 'text-sm text-slate-600',
})``;
